import axios from 'axios'
import store from '../store.js'


// 自定义实例默认值
const newAxios = axios.create({
    baseURL: store.state.baseUrl,  //--------------------------------------------------------------------------------
    timeout: 30 * 1000
})

// 添加请求拦截器  config：请求参数配置
newAxios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // config.headers['vtoken'] = 'ab6f694a-ebca-4d18-a270-10c67d32ea52';    //-----------------------------------------------------------------------------------------
    config.headers['vtoken'] = store.state.vtoken;
    // 默认值与接口传来的参数进行合并（注：接口参数与默认值不可重复）
    // config.data = Object.assign(defaultParams, config.data);
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});


// 添加响应拦截器   response：返回的所有内容
newAxios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
}, error => {
    // 请求返回报错时，使用弹出
    /*if (error.response.status === 401) {
        console.log('登录过期，请先登录');
    }*/
    if(error&&error.response){
        return Promise.reject(error.response)
    }else{
        return Promise.reject({"code": -1,"msg": "请求失败"})
    }
    // return Promise.reject(error.response)
});

export default newAxios